import {useEffect} from "react";
import {Dialog} from "primereact/dialog";
import {ButtonInput} from "../../components/ButtonInput/ButtonInput";
import {RoleType} from "../../models/Role";
import {activeUser} from "../../services/AuthService";
import "./DispositionsList.scss";
import {Disposition} from "../../models/Disposition";
import {decodeVehicleType} from "../../mock/StaticData";
import {useNavigate} from "react-router-dom";
import {ProductType} from "../../models/Product";
import {useTranslation} from "react-i18next";

// show triggers popup by changing the value
export interface DispositionsListProps {
    visible: boolean;
    handleClose: () => void
    dispositions: Disposition[]
    buttonLabel?: string;
    buttonIcon?: string;
    buttonStyle?: React.CSSProperties;
    buttonSaveStyle?: React.CSSProperties;
    buttonNewCityStyle?: React.CSSProperties;
    buttonInactiveStyle?: React.CSSProperties;
};

export const DispositionsList = (p: DispositionsListProps) => {
    const {
        visible,
        handleClose,
        dispositions,
        buttonLabel,
        buttonIcon,
        buttonStyle,
        buttonSaveStyle,
        buttonNewCityStyle,
        buttonInactiveStyle
    } = p;

    const navigate = useNavigate();
    const {t} = useTranslation();

    useEffect(() => {
    }, [])

    let addButtonStyle: React.CSSProperties = {};
    if (buttonStyle) {
        addButtonStyle = buttonStyle
    } else {
        addButtonStyle.background = "rgba(0, 165, 83, 1)";
        addButtonStyle.border = "none";
    };

    // TODO: Should CSS be in a separate file? Why here?
    let addButtonSaveStyle: React.CSSProperties = {};
    if (buttonSaveStyle) addButtonSaveStyle = buttonSaveStyle;

    let addButtonNewCityStyle: React.CSSProperties = {};
    if (buttonNewCityStyle) addButtonNewCityStyle = buttonNewCityStyle;

    let addButtonInactiveStyle: React.CSSProperties = {};
    if (buttonInactiveStyle) addButtonInactiveStyle = buttonInactiveStyle;

    const header = (
        <div className="header">
            <span className="p-dialog-titlebar-icon p-link">
                <i className="bi bi-person-lines-fill" style={{fontSize: 16}}></i>
            </span>
            <span>{t(`List dispozicija na relaciji`)}</span>
        </div>
    );

    const footer = (
        <div className="footer-buttons">
            <ButtonInput
                labelText={t('Zatvori')}
                onButtonClick={handleClose}
                addStyle={addButtonInactiveStyle}
                disabled={!(activeUser.role?.name === RoleType.Superadmin || activeUser.role?.name === RoleType.Administrator || activeUser.role?.name === RoleType.Warehouseman)}
            />
        </div>
    );

    return (
        <>
            <Dialog
                header={header}
                visible={visible}
                style={{ width: '50vw' }}
                className="dispositions-list-modal"
                footer={footer}
                blockScroll={false}
                draggable={false}
                onHide={handleClose}
            >
                <div className="dispositions-list-body">
                    {/*{JSON.stringify(dispositions)}*/}
                    <table style={{width: "100%", borderCollapse: "collapse"}}>
                        <tr style={{fontWeight: "bold", borderBottom: "1px solid #198754"}}>
                            <th style={{padding: "5px 10px", textAlign: "left", borderBottom: "1px solid #198754"}}>{t('Registracija')}</th>
                            <th style={{padding: "5px 10px", textAlign: "left", borderBottom: "1px solid #198754"}}>{t('Tip vozila')}</th>
                            <th style={{padding: "5px 10px", textAlign: "left", borderBottom: "1px solid #198754"}}>{t('Ime vozača')}</th>
                            <th style={{padding: "5px 10px", textAlign: "left", borderBottom: "1px solid #198754"}}></th>
                        </tr>
                        {dispositions.map((disposition) => (
                            <tr style={{ borderBottom: "1px solid #198754"}}>
                                <td style={{padding: "5px 10px", borderBottom: "1px solid #198754"}}>{disposition.registrationNumber?.toUpperCase()}</td>
                                <td style={{padding: "5px 10px", borderBottom: "1px solid #198754"}}>{decodeVehicleType(disposition.vehicleTypeId)}</td>
                                <td style={{padding: "5px 10px", borderBottom: "1px solid #198754"}}>{disposition.driverName}</td>
                                <td style={{padding: "5px 10px", borderBottom: "1px solid #198754"}}>
                                    <ButtonInput
                                        addStyle={{border: "none", background: "#198754" }}
                                        labelText={''} icon="bi bi-pencil"
                                        onButtonClick={() => {
                                            if (disposition.request?.product?.type == ProductType.RawMaterial) {
                                                navigate(`/mercantile-request-details/${disposition.request?.id}`)
                                            } else {
                                                navigate(`/repro-request-details/${disposition.request?.id}`)
                                            }
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </table>
                </div>
            </Dialog>
        </>
    );
};
